import React, { useMemo } from "react";
import { ResponsiveText } from "@usap/uicomponents";

export default function Label({
  color = "dark-2",
  weight = "bold",
  size = "medium",
  children,
  ...rest
}) {
  const textSize = useMemo(() => {
    return { small: ["14px", "12px"], medium: ["16px", "14px"] };
  }, []);

  const [desktopSize, mobileSize] = textSize[`${size}`];
  const responsiveSize = { large: desktopSize, other: mobileSize };
  return (
    <ResponsiveText
      weight={weight}
      color={color}
      fxSize={responsiveSize}
      {...rest}
    >
      {children}
    </ResponsiveText>
  );
}
